import { useMutation, useQueryClient } from '@tanstack/react-query'
import { configService } from '@/app/services/configService'
import { useToast } from '@/view/components/ui/use-toast'
import { PartnerType } from '@/app/utils/partners.enum'
import { TriStateEnum } from '@/app/entities/TriState'

export const useEnableAndDisablePartnersController = (params: {
  isActive: boolean
  id: PartnerType
}) => {
  const { isActive, id } = params

  const queryClient = useQueryClient()
  const { toast } = useToast()

  const { mutateAsync, isPending } = useMutation({
    mutationFn: configService.patchConfigProducts,

    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ['productsConfig'] })

      toast({
        title: `Parceiro ${
          response?.success
            ? isActive
              ? 'desabilitado'
              : 'habilitado'
            : 'atualizado'
        } com sucesso!`,
      })
    },

    onError: () => {
      toast({
        title: 'Erro ao atualizar parceiro.',
        description: 'Tente novamente mais tarde.',
        variant: 'destructive',
      })
    },
  })

  const handleConfirm = async () => {
    const newState = isActive ? TriStateEnum.ON : TriStateEnum.FULL
    await mutateAsync({
      type: id,
      state: newState,
      isActive,
    })
  }

  return {
    handleConfirm,
    isPending,
  }
}
